<template>
  <select
    @change="changedValue($event.target.value)"
  >
    <option
      v-for="(amout, index) in this.amounts"
      :key="index"
      :selected="amout.val == showingVal"
      :value="amout.val"
    >
      {{amout.name}}
    </option>
  </select>
</template>

<script>
	export default {
    computed : {},
    props: {
      totalItems: Number,
    },
    mounted(){
      this.generateAmounts()
    },
    data() {
      return {
        showingVal: 9,
        amounts: []
      }
    },
    methods: {
      generateAmounts() {
        var that = this
        this.amounts = [
          {name: 'min', val: 9},
          {name: '25', val: 25},
          {name: '50', val: 50},
          {name: '100', val: 100},
        ]
      },
      changedValue(value) {
        this.showingVal = parseInt(value)
        this.$emit('selectedAmount', parseInt(value))
      }
    }
	}
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

select {
  font-size: 12px;
  width: 64px;
  height: 30px;
  color: #707070;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #EFEFEF;
  outline: none;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  font-weight: 500;
  background-color: #FFFFFF;
  resize: none;

  &:focus {
    color: #707070;
    border: 1px solid #707070;
  }
  &:disabled {
    background-color: #F8F8F8;
    border: 1px solid #EEEEEE;
    color: #C6C6C6;
  }

  option {
    font-size: 12px;
  }
}

</style>
